/**
 * Health Score v1.2 frontend flag.
 *
 * Prefer `REACT_APP_HEALTH_V12=true`. When the KPI payload already includes
 * `security_health_v12`, v1.2 mode is used automatically so coverage layers
 * never fall back to inventing scores from legacy `health_*` fields.
 */
export function isHealthV12Enabled(env = process.env) {
  return String(env?.REACT_APP_HEALTH_V12 || '').trim().toLowerCase() === 'true';
}

/** True when the overview KPI payload includes a v1.2 health block. */
export function hasSecurityHealthV12(summary) {
  return Boolean(
    summary
    && typeof summary === 'object'
    && summary.security_health_v12
    && typeof summary.security_health_v12 === 'object'
    && !Array.isArray(summary.security_health_v12)
    && Object.keys(summary.security_health_v12).length > 0
  );
}

/**
 * Resolve whether to read health from `security_health_v12` only.
 * Explicit `enabled` wins (tests / callers). Otherwise: env flag, then payload.
 */
export function resolveHealthV12Mode({ enabled, summary } = {}, env = process.env) {
  if (enabled === true || enabled === false) return enabled;
  if (isHealthV12Enabled(env)) return true;
  return hasSecurityHealthV12(summary);
}
